import { Outlet, NavLink } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import {
  LayoutDashboard,
  Globe,
  Users,
  Images,
  ListTodo,
  LogOut,
  Star,
  FolderTree,
  HardDrive,
  ServerCog,
  PlayCircle,
  Gamepad2,
  AlertCircle,
  Upload,
  FileSearch
} from 'lucide-react'

const navItems = [
  { path: '/', icon: LayoutDashboard, label: 'Панель' },
  { path: '/sources', icon: Globe, label: 'Источники' },
  { path: '/authors', icon: Users, label: 'Авторы' },
  { path: '/images', icon: Images, label: 'Изображения' },
  { path: '/categories', icon: FolderTree, label: 'Категории' },
  { path: '/quality', icon: Star, label: 'Качество' },
  { path: '/uploads', icon: Upload, label: 'Загрузки' },
  { path: '/queue', icon: ListTodo, label: 'Очередь' },
  { path: '/webmaster-audit', icon: FileSearch, label: 'Аудит Вебмастера' },
  { path: '/system', icon: ServerCog, label: 'Система' },
  { path: '/storage', icon: HardDrive, label: 'Хранилище' },
  { path: '/tests', icon: PlayCircle, label: 'E2E-тесты' },
  { path: '/game', icon: Gamepad2, label: 'Монитор игры' },
  { path: '/errors', icon: AlertCircle, label: 'Журнал ошибок' },
]

export default function Layout() {
  const { logout, user } = useAuth()

  return (
    <div className="min-h-screen">
      {/* Sidebar */}
      <aside className="sidebar">
        <div className="mb-8">
          <h1 className="text-xl font-bold gradient-text">Aggregator</h1>
          <p className="text-sm opacity-50">Панель управления парсером</p>
        </div>

        <nav className="space-y-1">
          {navItems.map(({ path, icon: Icon, label }) => (
            <NavLink
              key={path}
              to={path}
              end={path === '/'}
              className={({ isActive }) =>
                `sidebar-link ${isActive ? 'active' : ''}`
              }
            >
              <Icon size={20} />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="absolute bottom-6 left-6 right-6 space-y-3">
          {user && (
            <div className="text-center text-sm opacity-60">
              {user.username}
            </div>
          )}
          <button
            onClick={logout}
            className="w-full flex items-center justify-center gap-2 p-3 rounded-lg bg-white/5 hover:bg-white/10 transition-colors text-red-400"
          >
            <LogOut size={18} />
            <span>Выйти</span>
          </button>
          <div className="glass p-3 text-center">
            <p className="text-xs opacity-50">Aggregator v1.0</p>
          </div>
        </div>
      </aside>

      {/* Main content */}
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  )
}
